import { useLocation } from 'react-router-dom';

const translations = {
  zh: {
    'app.name': 'CARLA 挑战赛',
    'nav.home': '主页',
    'nav.competitions': '赛事大厅',
    'nav.login': '登录',
    'nav.settings': '设置',
    'nav.dashboard': '我的数据',
    'settings.language': '语言',
    'settings.theme': '主题',
    'settings.zh': '中文',
    'settings.en': 'English',
    'settings.dark': '黑色模式',
    'settings.light': '白色模式',
    'home.title': 'Bench2Drive 自动驾驶排行榜',
    'home.subtitle': '面向闭环端到端自动驾驶的多能力评测基准',
    'home.cta.comp': '进入赛事大厅',
    'home.cta.getStarted': '快速开始',
    'home.cta.official': '官方网站',
    'home.features': '功能亮点',
    'home.feature.multi.title': '多能力评测',
    'home.feature.multi.desc': '覆盖超车、并线、紧急制动与交通标志识别等多种驾驶能力',
    'home.feature.think.title': 'Think2Drive 融合',
    'home.feature.think.desc': '结合 Think2Drive 教师模型，实现潜在世界模型中的高效强化学习',
    'home.feature.metrics.title': '高级指标',
    'home.feature.metrics.desc': '提供综合得分、路线完成度、处罚系数、效率与平顺性等指标',
    'home.feature.routes.title': '220 条挑战路线',
    'home.feature.routes.desc': '覆盖城市与高速的 220 条精心设计路线',
    'home.about.title': '关于 Bench2Drive 排行榜',
    'home.about.p1': 'Bench2Drive 是一个用于评测闭环端到端自动驾驶系统的综合基准。',
    'home.about.p2': '基于 CARLA 并融合 Think2Drive，覆盖 220 条路线，衡量安全、效率与平顺性。',
    'home.overview': '项目总览',
    'home.video': '介绍视频',
    'home.ready': '准备参赛？',
    'home.ready.desc': '加入排行榜，展示你的自动驾驶方案',
    'home.ready.cta': '立即开始',
    'getStarted.title': '快速开始',
    'getStarted.desc': '教程页面即将上线。',
    'getStarted.back': '返回主页',
    'competition.title': '赛事管理中心',
    'competition.search': '搜索比赛',
    'competition.my': '我正在参加的比赛',
    'competition.all': '全部比赛',
    'competition.enter': '进入比赛',
    'competition.teamManage': '团队管理',
    'competition.apply': '申请加入',
    'competition.view': '查看详情',
    'competition.leaderboard': '排行榜',
    'competition.teamJoin': '小队创建/加入',
    'competition.myData': '我的数据',
    'competition.members': '团队成员',
    'competition.loginFirst': '请先登录后加入或创建小队',
    'competition.toLogin': '去登录',
    'competition.deadline': '截止',
    'competition.notFound': '未找到比赛',
    'competition.backToLobby': '返回赛事大厅',
    'competition.membersManage': '团队成员管理',
    'competition.requests': '加入申请通知',
    'competition.requestedJoin': '提交了入队申请',
    'competition.noRequests': '暂无加入申请',
    'competition.status.active': '进行中',
    'competition.status.upcoming': '即将开始',
    'competition.status.closed': '已结束',
    'team.join.disabled': '无法加入',
    'team.create.namePlaceholder': '请输入小队名称',
    'team.create.descPlaceholder': '奔着冠军去的',
    'team.create.descDefault': '奔着冠军去的',
    'team.create.sizeRange': '人数范围',
    'team.join.placeholder': '填写申请理由',
    'role.siteAdmin': '系统管理员',
    'role.competitionAdmin': '赛事管理员',
    'role.user': '普通用户',
    'user.username': '用户名',
    'user.role': '角色',
    'user.registry': 'Registry',
    'user.logout': '退出登录',
    'action.approve': '同意',
    'action.reject': '拒绝',
    'team.onboarding.title': '加入或创建小队',
    'team.onboarding.create': '创建小队',
    'team.status.pending': '审核中',
    'team.status.rejected': '已拒绝',
    'team.status.full': '已满员',
    'team.status.open': '招募中',
    'team.apply': '申请加入',
    'team.captain': '队长',
    'team.members': '成员',
    'team.description': '描述',
    'modal.create.title': '创建小队',
    'modal.create.name': '小队名称',
    'modal.create.desc': '小队宣言',
    'modal.create.size': '小队人数',
    'modal.create.cancel': '取消',
    'modal.create.confirm': '确认创建',
    'modal.join.title': '申请加入小队',
    'modal.join.target': '目标小队',
    'modal.join.message': '申请留言',
    'modal.join.submit': '提交申请',
    'dashboard.title': '我的测评数据',
    'dashboard.subtitle': '查看测评历史和详细结果',
    'dashboard.tab.latest': '最新测评',
    'dashboard.tab.history': '历史记录',
    'dashboard.tab.charts': '数据趋势',
    'dashboard.progress': '测评进度',
    'dashboard.scenario': '场景',
    'dashboard.score.total': '综合得分',
    'dashboard.score.route': '路线完成度',
    'dashboard.score.penalty': '惩罚系数',
    'dashboard.exceptions': '异常信息',
    'dashboard.details': '场景详情',
    'dashboard.noRecords': '暂无测评记录',
    'dashboard.submitTime': '提交时间',
    'dashboard.status': '测评状态',
    'dashboard.progressDetail': '完成进度',
    'dashboard.progressLabel': '进度',
    'dashboard.scoreLabel': '得分',
    'dashboard.loading': '加载中...',
    'dashboard.version': '版本',
    'dashboard.infractions': '次违规',
    'dashboard.trend.title': '综合得分趋势',
    'dashboard.trend.notice': '需要至少两次完成的测评才能显示趋势图',
    'dashboard.summary': '统计摘要',
    'dashboard.summary.total': '总测评次数',
    'dashboard.summary.completed': '完成测评',
    'dashboard.summary.best': '最高得分',
    'dashboard.summary.avg': '平均得分',
    'dashboard.video.warning': '⚠️ 警告：视频生成一周后将会被删除，请及时保存视频。',
    'dashboard.video.download': '下载 MP4',
    'leaderboard.title': '排行榜',
    'leaderboard.subtitle': '实时排名数据',
    'leaderboard.mockNotice': '当前显示模拟数据',
    'leaderboard.rank': '排名',
    'leaderboard.team': '团队名称',
    'leaderboard.score.total': '综合得分',
    'leaderboard.score.route': '路线得分',
    'leaderboard.score.penalty': '惩罚系数',
    'leaderboard.members': '成员',
    'leaderboard.loading': '加载中...',
    'leaderboard.missingCompetition': '缺少比赛ID',
    'status.running': '运行中',
    'status.finished': '已完成',
    'status.failed': '失败',
    'competition.status.undefined': '未定义',
    'auth.login.title': '欢迎回来',
    'auth.login.subtitle': '登录您的账户继续',
    'auth.register.title': '创建账户',
    'auth.register.subtitle': '加入自动驾驶挑战赛',
    'auth.username': '用户名',
    'auth.password': '密码',
    'auth.email': '邮箱',
    'auth.team': '团队名称',
    'auth.confirm': '确认密码',
    'auth.remember': '记住我',
    'auth.forgot': '忘记密码？',
    'auth.login': '登录',
    'auth.login.loading': '登录中...',
    'auth.register': '注册',
    'auth.register.loading': '注册中...',
    'auth.noAccount': '还没有账户？',
    'auth.hasAccount': '已有账户？',
    'auth.toRegister': '立即注册',
    'auth.toLogin': '立即登录',
    'auth.backHome': '返回首页',
    'auth.agree': '我已阅读并同意',
    'auth.terms': '服务条款',
    'auth.error.required': '请填写所有字段',
    'auth.error.passwordLen': '密码长度至少为6位',
    'auth.error.passwordMatch': '两次输入的密码不一致',
    'auth.error.email': '请输入有效的邮箱地址',
    'auth.error.registerFailed': '注册失败，请稍后重试',
    'auth.success.register': '注册成功，请登录'
  },
  en: {
    'app.name': 'CARLA Challenge',
    'nav.home': 'Home',
    'nav.competitions': 'Competitions',
    'nav.login': 'Login',
    'nav.settings': 'Settings',
    'nav.dashboard': 'Dashboard',
      'home.title': 'Bench2Drive Autonomous Driving Leaderboard',
      'home.subtitle': 'Towards Multi-Ability Benchmarking of Closed-Loop End-To-End Autonomous Driving',
      'home.cta.comp': 'Go to Competitions',
      'home.cta.getStarted': 'Get Started',
      'home.cta.official': 'Official Website',
      'home.features': 'Features',
      'home.feature.multi.title': 'Multi-Ability Benchmarking',
      'home.feature.multi.desc': 'Comprehensive evaluation across multiple driving abilities including overtaking, merging, emergency braking, and traffic sign recognition',
      'home.feature.think.title': 'Think2Drive Integration',
      'home.feature.think.desc': 'Powered by Think2Drive teacher model for efficient reinforcement learning in latent world models for quasi-realistic autonomous driving',
      'home.feature.metrics.title': 'Advanced Metrics',
      'home.feature.metrics.desc': 'Track driving score, route completion, infraction penalties, driving efficiency, and driving smoothness metrics',
      'home.feature.routes.title': '220 Challenge Routes',
      'home.feature.routes.desc': 'Comprehensive test suite with 220 carefully designed routes covering diverse urban and highway scenarios',
      'home.about.title': 'About Bench2Drive Leaderboard',
      'home.about.p1': 'Bench2Drive is a comprehensive benchmark for evaluating closed-loop end-to-end autonomous driving systems.',
      'home.about.p2': 'Built on the CARLA simulator with Think2Drive integration, Bench2Drive offers 220 carefully designed routes covering urban and highway scenarios.',
      'home.overview': 'Project Overview',
      'home.video': 'Introduction Video',
      'home.ready': 'Ready to compete?',
      'home.ready.desc': 'Join the leaderboard and showcase your autonomous driving solution',
      'home.ready.cta': 'Get Started Now',
      'getStarted.title': 'Get Started',
      'getStarted.desc': 'Tutorial page coming soon.',
      'getStarted.back': 'Back to Home',
    'settings.language': 'Language',
    'settings.theme': 'Theme',
    'settings.zh': '中文',
    'settings.en': 'English',
    'settings.dark': 'Dark mode',
    'settings.light': 'Light mode',
    'competition.title': 'Competition Center',
    'competition.search': 'Search competitions',
    'competition.my': 'My Competitions',
    'competition.all': 'All Competitions',
    'competition.enter': 'Enter',
    'competition.teamManage': 'Team',
    'competition.apply': 'Apply',
    'competition.view': 'Details',
    'competition.leaderboard': 'Leaderboard',
    'competition.teamJoin': 'Create/Join Team',
    'competition.myData': 'My Data',
    'competition.members': 'Team Members',
    'competition.loginFirst': 'Please login to create or join a team',
    'competition.toLogin': 'Go to Login',
    'competition.deadline': 'Deadline',
    'competition.notFound': 'Competition not found',
    'competition.backToLobby': 'Back to competitions',
    'competition.membersManage': 'Team member management',
    'competition.requests': 'Join requests',
    'competition.requestedJoin': 'submitted a join request',
    'competition.noRequests': 'No join requests',
    'competition.status.active': 'Ongoing',
    'competition.status.upcoming': 'Upcoming',
    'competition.status.closed': 'Closed',
    'team.join.disabled': 'Unavailable',
    'team.create.namePlaceholder': 'Enter team name',
    'team.create.descPlaceholder': 'Chasing the championship',
    'team.create.descDefault': 'Chasing the championship',
    'team.create.sizeRange': 'Team size range',
    'team.join.placeholder': 'Write a message',
    'role.siteAdmin': 'Site Admin',
    'role.competitionAdmin': 'Competition Admin',
    'role.user': 'User',
    'user.username': 'Username',
    'user.role': 'Role',
    'user.registry': 'Registry',
    'user.logout': 'Sign out',
    'action.approve': 'Approve',
    'action.reject': 'Reject',
    'action.back': 'Back',
    'team.onboarding.title': 'Join or Create Team',
    'team.onboarding.create': 'Create Team',
    'team.status.pending': 'Pending',
    'team.status.rejected': 'Rejected',
    'team.status.full': 'Full',
    'team.status.open': 'Open',
    'team.apply': 'Apply',
    'team.captain': 'Captain',
    'team.description': 'Description',
    'team.members': 'Members',
    'modal.create.title': 'Create Team',
    'modal.create.name': 'Team Name',
    'modal.create.desc': 'Team Motto',
    'modal.create.size': 'Team Size',
    'modal.create.cancel': 'Cancel',
    'modal.create.confirm': 'Create',
    'modal.join.title': 'Apply to Team',
    'modal.join.target': 'Target Team',
    'modal.join.message': 'Application Message',
    'modal.join.submit': 'Submit',
    'dashboard.title': 'My Evaluation Data',
    'dashboard.subtitle': 'Review history and detailed results',
    'dashboard.tab.latest': 'Latest',
    'dashboard.tab.history': 'History',
    'dashboard.tab.charts': 'Trends',
    'dashboard.progress': 'Progress',
    'dashboard.scenario': 'Scenarios',
    'dashboard.score.total': 'Overall Score',
    'dashboard.score.route': 'Route Score',
    'dashboard.score.penalty': 'Penalty',
    'dashboard.exceptions': 'Exceptions',
    'dashboard.details': 'Scenario Details',
    'dashboard.noRecords': 'No evaluation records yet',
    'dashboard.submitTime': 'Submitted',
    'dashboard.status': 'Status',
    'dashboard.progressDetail': 'Progress',
    'dashboard.progressLabel': 'Progress',
    'dashboard.scoreLabel': 'Score',
    'dashboard.loading': 'Loading...',
    'dashboard.version': 'Version',
    'dashboard.infractions': 'Infractions',
    'dashboard.trend.title': 'Overall Score Trend',
    'dashboard.trend.notice': 'At least two completed evaluations are required to show trends',
    'dashboard.summary': 'Summary',
    'dashboard.summary.total': 'Total Evaluations',
    'dashboard.summary.completed': 'Completed',
    'dashboard.summary.best': 'Best Score',
    'dashboard.summary.avg': 'Average Score',
    'dashboard.video.warning': '⚠️ Warning: The generated video will be deleted after one week. Please save it in time.',
    'dashboard.video.download': 'Download MP4',
    'leaderboard.title': 'Leaderboard',
    'leaderboard.subtitle': 'Live ranking data',
    'leaderboard.mockNotice': 'Showing mock data',
    'leaderboard.rank': 'Rank',
    'leaderboard.team': 'Team',
    'leaderboard.score.total': 'Overall Score',
    'leaderboard.score.route': 'Route Score',
    'leaderboard.score.penalty': 'Penalty',
    'leaderboard.members': 'Members',
    'leaderboard.loading': 'Loading...',
    'leaderboard.missingCompetition': 'Missing competition ID',
    'status.running': 'Running',
    'status.finished': 'Finished',
    'competition.status.undefined': 'Undefined',
    'status.failed': 'Failed',
    'auth.login.title': 'Welcome Back',
    'auth.login.subtitle': 'Sign in to continue',
    'auth.register.title': 'Create Account',
    'auth.register.subtitle': 'Join the autonomous driving challenge',
    'auth.username': 'Username',
    'auth.password': 'Password',
    'auth.email': 'Email',
    'auth.team': 'Team Name',
    'auth.confirm': 'Confirm Password',
    'auth.remember': 'Remember me',
    'auth.forgot': 'Forgot password?',
    'auth.login': 'Login',
    'auth.login.loading': 'Logging in...',
    'auth.register': 'Register',
    'auth.register.loading': 'Registering...',
    'auth.noAccount': "Don't have an account?",
    'auth.hasAccount': 'Already have an account?',
    'auth.toRegister': 'Create one',
    'auth.toLogin': 'Sign in',
    'auth.backHome': 'Back to Home',
    'auth.agree': 'I have read and agree to',
    'auth.terms': 'Terms of Service',
    'auth.error.required': 'Please fill in all fields',
    'auth.error.passwordLen': 'Password must be at least 6 characters',
    'auth.error.passwordMatch': 'Passwords do not match',
    'auth.error.email': 'Please enter a valid email address',
    'auth.error.registerFailed': 'Registration failed. Please try again later.',
    'auth.success.register': 'Registration successful. Please login.'
  }
};

export const getLangFromPath = (pathname = '') => {
  if (pathname.includes('/zh-cn')) return 'zh';
  if (pathname.includes('/en-us')) return 'en';
  // 默认为英文
  return 'en';
};

export const t = (key, lang = 'en') => translations[lang]?.[key] || translations.en[key] || key;

export const useI18n = () => {
  const { pathname } = useLocation();
  const lang = getLangFromPath(pathname);
  
  // 修复 basePath 逻辑
  let basePath = '';
  
  // 检查语言前缀（优先级最高）
  if (pathname.includes('/zh-cn')) {
    basePath = '/zh-cn';
  } else if (pathname.includes('/en-us')) {
    basePath = '/en-us';
  }
  // 如果没有语言前缀，basePath 为空字符串（默认英文路由）
  
  return {
    t: (key) => t(key, lang),
    lang,
    basePath
  };
};
